import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import humanResource, { HRactions } from "../../../redux/redux";
import { AiOutlineDelete } from "react-icons/ai";
import { BiEdit } from "react-icons/bi";
import axios from "axios";
import PositionedSnackbar from "../../../components/snackbar";
import { UseHrApp } from "../../../utils/context";

export default function Department() {
  const employees = [];
  const dispatch = useDispatch();
  const [name, setname] = useState("");
  const [show, setshow] = useState(false);
  const [text, settext] = useState("");
  const [severity, setseverity] = useState("error");

  async function CreateDepartment() {
    try {
      const token = localStorage.getItem("token");
      const res = await axios({
        url: "https://hr-app-api.onrender.com/api/department/create",
        data: {
          name: name,
        },
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res?.data?.status) {
        settext("Department successfully added");
        setshow(true);
        setseverity("success");
        setname("");
        GetDepartMents();
      }
    } catch (error) {
      settext("Error");
      setshow(true);
      setseverity("error");
    }
  }
  
  const { departments, GetDepartMents } = UseHrApp();

  useEffect(() => {
    GetDepartMents();
  }, []);

  return (
    <div className="min-w-screen min-h-[91vh] bg-[#f4f8fd] font-[Archivo] ">
      <div className=" p-3 md:pl-[16em] lg:pl-[16em] lg:pr-[1em] xl:pl-[17em] xl:pr-[2em] w-full pt-[1em] ">
        <div className=" w-full flex justify-between items-center">
          <p className=" font-[Archivo] lg:text-2xl font-semibold">
            Department
          </p>
        </div>
        <section className=" grid h-[90vh] gap-[2em] grid-cols-2 mt-[1.5em] ">
          <div className=" w-[80%] red h-max bg-[white]">
            <div className=" p-4 border-2 b">
              <p className=" text-xl font-bold">Add Department</p>

              <div className=" flex flex-col gap-3">
                <label htmlFor="DepartmentName" className=" text-sm">
                  Department Name
                </label>
                <input
                  type="text"
                  id="DepartmentName"
                  name="DepartmentName"
                  className=" bord border-[black] border-solid p-1 w-full h-[2.1rem] bg-[#f4f8fd] "
                  value={name}
                  onChange={(e) => setname(e.target.value)}
                />
              </div>

              <div className=" w-full flex gap-2 items-center  mt-[1em]">
                <button
                  className=" w-[100px] p-2 bg-[#318d12]  font-semibold text-[white]"
                  onClick={CreateDepartment}
                >
                  Save
                </button>
                <button
                  className=" w-[100px] p-2 bg-[#F2594A] font-semibold text-white"
                  onClick={()=>{
                    setname('')
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>

          <div className="">
            <div>
              <table className="w-max divide-y divide-gray-200">
                <thead>
                  <tr>
                    <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Department Name
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {departments.map((item, index) => {
                    const delDep = () => {
                      const index = departments.indexOf(item.name);
                      dispatch(HRactions.deleteDepartment(index));
                    };
                    return (
                      <tr
                        key={item.index}
                        className={index % 2 !== 0 ? "bg-[#f0f0f0]" : ""}
                      >
                        <td className="px-4 py-4 whitespace-no-wrap text-black">
                          {item.name}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
      <PositionedSnackbar
        value={show}
        setshow={setshow}
        text={text}
        severity={severity}
      />
    </div>
  );
}

/*   
<td className="px-4 py-4 whitespace-no-wrap">
                          <div className=" flex gap-3 h-[1.4em]">
                       
                          </div>
                        </td>
                            <button
                              className=" bord w-[35px] flex items-center justify-center bg-[#f34646]"
                              onClick={delDep}
                            >
                              <AiOutlineDelete color="white" />{" "}
                            </button> */
